// extracted by mini-css-extract-plugin
export default {"iconWrapper":"icon-wrapper__AWGAkgPd","conversionWindowInput":"conversion-window-input__hyhSEMLQ","withinLabel":"within-label__Y350vpXF"};